<template>
  <div class="schedule-outer">
    <div class="schedule-oper">
      <span class="week" @click="prevWeek">上一周</span>
      <span class="week" @click="nowWeek">本周</span>
      <a-week-picker @change="chooseWeek" v-model="weekMoment" />
      <span class="date">{{weekDate.minAttendDate}} ~ {{weekDate.maxAttendDate}}</span>
      <span class="week" @click="nextWeek">下一周</span>
      <span class="week" @click="today">今天</span>
    </div>
    <div
      class="cells-classroom classroom-header"
      v-if="showClassRoom"
    >
      <span style="position: absolute; top: 4px; right: 6px">星期/时段</span>
      <span style="position: absolute; bottom: 4px; left: 6px">场地/容量</span>
      <span class="line"></span>
    </div>
    <div
      class="schedule-inner"
      id="schedule-inner"
      v-if="classroomList && classroomList.length > 0"
    >
      <div class="left" v-if="showClassRoom">
        <div class="content">
          <div
            class="cells-classroom table-cells"
            v-for="(item, index) in classroomList"
            :key="index"
          >
            <span class="left">
              <div class="name">
                <span>{{ item.placeName }}</span>
              </div>
            </span>
            <span class="right"><span v-if="item.capacity>0">{{ item.capacity }}人</span><span v-if="item.capacity<0">不限人数</span></span>
          </div>
        </div>
      </div>
      <div class="right">
        <ul class="schedule-header">
          <!-- {{tableData['2020-01-13']}} -->
          <li v-for="(dayData, key, index) in tableData" :key="index">
            <div class="cells-day"><span>{{ key }}</span>
              <p>
                <a href="#" title="打印对应日期的全天课程待签到老师和学生信息" :data="key" @click="printDailySchedule(key)">打印</a>
                <a href="#" title="导出对应日期的全天课程待签到老师，用于汇总数据" :data="key" @click="printDailyScheduleExport(key)">导出</a>
                <a title="当日排班报告" @click="openDrawer(key)">日报</a>
              </p>
            </div>
            <div class="col-name">
              <span
                class="table-cells cells-time"
                v-for="(classroomData, key, index) in dayData"
                :key="index"
                >{{ classroomData.key }}</span
              >
            </div>
          </li>
        </ul>
        <div class="schedule-table">
          <div
            style="display: inline-block"
            v-for="(dayData, key1, index) in tableData"
            :key="index"
          >
            <ul v-for="(classroomData, key, index) in dayData" :key="index">
              <!-- <span style="font-size: 10px">{{classroomData}}</span> -->
              <li
                v-for="(item, key, index) in classroomData.scheduleList"
                :key="index"
                @click="item.courseName && $refs.courseDetail.init(item)"
                class="table-cells cells-content hover-active"
                :class="{
                  'cells-content-active': item.courseName,
                  'cells-bg': key1 == moment().format('YYYY-MM-DD'),
                }"
              >
                <a-popover v-if="item.courseName" placement="right">
                  <template slot="content">
                    <div class="course-detail">
                      <div class="header"></div>
                      <div class="content">
                        <div class="title">课程名称：{{ item.courseName }}</div>
                        <div class="desc">课程码：{{ item.courseCode }}</div>
                        <div class="desc">班级名称：{{ item.className }}</div>
                        <div class="gap"></div>
                        <div class="desc">时间：{{ item.classTime }}</div>
                        <div class="desc">教室：{{ item.placeName }}</div>
                        <div class="desc">老师名称：{{ item.teacherName }}</div>
                        <div class="desc">上课校区：{{ item.schoolName }}</div>
                        <div class="desc">
                          课程方名称：{{ item.institutionName }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <span class="cells-content-desc">
                    <p>{{ item.courseName }}</p>
                    <p>{{ item.className }}</p>
                    <p>{{ item.teacherName }}</p>
                  </span>
                </a-popover>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <course-detail-modal ref="courseDetail"></course-detail-modal>
    <!-- 排班详情 -->
    <operationDetail v-if="showDetail" :showDetail.sync="showDetail" :attendDate="attendDate">
    </operationDetail>
  </div>
</template>
<script>
import school from "../../api/school";

import education from "../../api/education";

import course from "../../api/course";

import classroom from "../../api/classroom";

import moment from "moment";

import utils from "../../utils";

import CourseDetailModal from "./CourseDetailModal";
import globalConfig from '../../config/globle.config';

import operationDetail from "./components/operationDetail.vue";

const scheduleData = [
  { name: "周一", children: [{ startDate: "08:00", endDate: "09:00" }] },
];
export default {
  name: "schedule",
  data() {
    return {
      tableData: null,
      weekDate: {},
      weekMoment: moment(),
      classroomList: [{
              id:-1,
              placeName:"未设置教室",
              capacity:-1
            }],
      maxScheduleCount: -1,
      showDetail:false,
      attendDate:''
    };
  },
  components: {
    operationDetail,
    CourseDetailModal,
  },
  computed: {
    showClassRoom : function() {
      return this.tableData
        && this.classroomList
        && this.classroomList.length > 0
        && this.maxScheduleCount <= this.classroomList.length;
    },
  },
  methods: {
    moment,
    //获取教室列表
    getClassroomList_all() {
      classroom.getClassroomList_all().then((res) => {
        console.log("教室列表", res);
        if (res.data.length > 0)
          res.data.forEach(element => {
            this.classroomList.push(element);
          });
        this.init();
      });
    },
    //查找学校课表API
    printDailySchedule(params) {
      education.printDailySchedule(params).then((res) => {
        window.open(globalConfig.rootUrl + res.openPage);
      });
    },
    printDailyScheduleExport(params) {
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          education.printDailySchedule(params).then((res) => {
        window.open(globalConfig.rootUrl + res.openExport);
        });
        },
      })
    },
    //初始化
    init() {
      let tableData = [];
      let timeGap_value = this.classroomList;
      let table_value = [
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
        "周日",
      ];
      for (let i in table_value) {
        let key = parseInt(i);
        tableData.push({
          code: table_value[key],
          date: this.weekMoment.weekday(key).format("YYYY-MM-DD"),
        });
      }
      this.setWeekDate(this.weekMoment);
      this.searchSchedule(this.weekDate, tableData);
    },

    //获取一周的起始日期
    setWeekDate(momentData) {
      this.weekDate = {
        minAttendDate: momentData.startOf("week").format("YYYY-MM-DD"),
        maxAttendDate: momentData.endOf("week").format("YYYY-MM-DD"),
      };
    },

    //查找学校课表API
    searchSchedule(params, tableData) {
      education.getSchedule(params).then((res) => {
        //把当前周日期补全
        this.setWeek_all(res.data, tableData);
      });
    },

    //把当前周日期补全
    setWeek_all(res, _tableData) {
      let tempArray = [];

      //补全一周内7天
      _tableData.map((item, index) => {
        tempArray[item.date] = [];
      });
      Object.assign(tempArray, res);

      // 补全每天的时间段;
      let gapTimeList = [];
      education.getClassTimeList().then((res) => {
        gapTimeList = res.data.map((item) => {
          return {
            key: item.startTime + "-" + item.endTime,
            scheduleList: [],
          };
        });

        //补全时间
        for (let i in tempArray) {
          //如果为空的话
          if (utils.common.checkNullObj(tempArray[i])) {
            Object.assign(tempArray[i], utils.common.copy(gapTimeList));
          }
        }

        //补全教室
        let tempClassroomList = [];
        for (let i in this.classroomList) {
          let _classroom = this.classroomList[i];
          tempClassroomList.push({
            placeId: _classroom.id,
          });
        }
        this.setClassroom(tempClassroomList, tempArray);
      });
    },

    //设置教室
    setClassroom(classroomList, tableData) {
      //循环天
      var maxCount = 0;
      for (let i in tableData) {
        let dayData = tableData[i];
        //循环每天的时间段
        for (let j in dayData) {
          //循环所有教室
          let tempClassroomList = JSON.parse(JSON.stringify(classroomList));
          if (dayData[j].scheduleList.length > maxCount) {
            maxCount = dayData[j].scheduleList.length;
          }
          if(tempClassroomList.length > dayData[j].scheduleList.length) {
            for (let k in tempClassroomList) {
              //以存在的教室
              let existClassroom = null;
              //循环已有课的教室
              dayData[j].scheduleList.map((item) => {
                if (!item.placeId && tempClassroomList[k].placeId==-1) {
                  item.placeId = -1;
                  existClassroom = item;
                }
                else if (item.placeId == tempClassroomList[k].placeId) {
                  existClassroom = item;
                }
              });
              if (existClassroom) {
                Object.assign(tempClassroomList[k], existClassroom);
              }
            }
            dayData[j].scheduleList = tempClassroomList;
          } else {
            //多数课程未设置教室，那么教室和排班不会一对一
          }
        }
      }
      this.$set(this, "maxScheduleCount", maxCount);
      this.$set(this, "tableData", utils.common.copy(tableData));
      this.scrollTable();
    },
    openDrawer(e){
      this.showDetail = true
      this.attendDate = e
    },
    chooseWeek(date) {
      //获取选择日期距离当前周日期
      this.weekMoment = date;
      this.init();
    },

    //本周
    nowWeek() {
      this.weekMoment = moment();
      this.init();
    },

    //上一周
    prevWeek() {
      let tempWeek = new moment(this.weekMoment);
      this.weekMoment = null;
      this.$set(this, "weekMoment", tempWeek.week(tempWeek.week() - 1));
      this.init();
    },

    //下一周
    nextWeek() {
      let tempWeek = new moment(this.weekMoment);
      this.weekMoment = null;
      this.$set(this, "weekMoment", tempWeek.week(tempWeek.week() + 1));
      this.init();
    },

    //今天
    async today() {
      this.nowWeek();
      this.scrollTable();
    },

    scrollTable() {
      var div = document.getElementById("schedule-inner");
      var today = moment().format("YYYY-MM-DD");
      if (div) {
        if (this.tableData[today]) {
          const count = this.tableData[today].length;
          const dayNum = moment().day() - 1;
          div.scrollTo(108 * count * dayNum, 0);
        } else {
          div.scrollTo(0, 0);
        }
      }
    },
    //设置显示范围

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        let req = JSON.parse(JSON.stringify(value));
        req.gradeScope = req.gradeScope.join();
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addCourse(req);
          } else {
            this.updateCourse(req);
          }
        }
      });
    },
    refreshSchool() {
      if (this.$store.getters.schoolId) {
        this.getClassroomList_all();
      }
    },
  },
  created() {
    
    if (this.$store.getters.schoolId) {
      this.getClassroomList_all();
    }
  },
};
</script>
<style lang="scss" scoped>
.hidden { display : none }
@import "src/config/var";

$cells-width: 108px;

.schedule-oper {
  font-size: 0px;
  text-align: center;
  // position: absolute;
  // top: 22px;
  // left: 50%;
  // transform: translateX(-50%);
  span {
    display: inline-block;
    font-size: 16px;
    padding: 6px 6px 10px;
    cursor: pointer;
  }
  .week {
    color: $primary-color-dark;
  }
  .date {
    padding: 0px 10px;
    margin: 0px 6px;
    border: 1px solid $normal-color-disabled;
    border-radius: 2px;
  }
}
.schedule-inner {
  overflow: auto;
  font-size: 0px;
  width: calc(100vw - 300px);
  height: calc(100vh - 230px);
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: atuo;
  .left {
    width: calc(#{$cells-width} + 80px);
    display: inline-block;
    white-space: normal;
    vertical-align: top;
    z-index: 999;
    position: sticky;
    top: 0px;
    left: 0px;
    .content {
      margin-top: 120px;
    }
  }
  .right {
    display: inline-block;
    width: calc(100% - #{$cells-width} - 30px);
    vertical-align: top;
  }
}
.classroom-header {
  height: 120px;
  width: $cells-width;
  position: absolute;
  z-index: 1000;
  overflow: hidden;
  .line {
    width: calc(#{$cells-width} + 120px);
    display: inline-block;
    height: 120px;
    border-top: 1px solid #e3e3e3 !important;
    -webkit-transform: rotate(90deg);
    transform: rotate(45deg);
    position: relative;
    top: 60px;
    right: 20px;
  }
}
.schedule-header {
  position: sticky;
  top: 0px;
  z-index: 999;
  li {
    display: inline-block;
    text-align: center;
  }
}

.table-cells {
  width: $cells-width;
  display: inline-block;
  background: #f5f5f5;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  height: 80px;
  padding: 0px 5px;
  line-height: 80px;
  border-left: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
}
.cells-classroom {
  width: calc(#{$cells-width} + 80px);
  background: #ededed !important;
  border-left: 1px solid #e3e3e3 !important;
  border-bottom: 1px solid #e3e3e3 !important;
  .left {
    width: $cells-width;
    display: inline-block;
    border-right: 1px solid #e3e3e3 !important;
    .name {
      display: flex;
      align-items: center;
      height: 80px;
      span {
        display: inline-block;
        line-height: 18px;
      }
    }
  }
  .right {
    display: inline-block;
    width: 60px;
    text-align: center;
  }
}
.cells-content {
  font-size: 14px;
}
.cells-content-desc {
  height: 80px;
  align-items: center;
  p {
    line-height: 24px;
    width: 300px;
    overflow: hidden;
  }
}
.cells-content-active {
  background: #b5dbff !important;
  color: #575757;
  border-left: 1px solid #d9ecff !important;
  border-bottom: 1px solid #d9ecff !important;
}
.cells-day,
.cells-time {
  height: 40px !important;
  line-height: 40px !important;
  background: #ededed !important;
  border-left: 1px solid #e3e3e3 !important;
}
.cells-day {
  height: 80px !important;
  font-size: 16px !important;
  border-bottom: 1px solid #e3e3e3 !important;
}
.cells-day a {
  font-size: 16px !important;
  margin-left: 0.5em;
}
.schedule-table {
  white-space: nowrap;
  ul {
    white-space: normal;
    vertical-align: top;
    font-size: 0px;
    width: $cells-width;
    display: inline-block;
    background: #f5f5f5;
  }
  .first-row {
    top: -4px !important;
  }
}
.course-detail {
  font-size: 14px;
  .header {
    width: 100%;
    height: 4px;
    background: $primary-color-dark;
  }
  .content {
    padding: 8px 20px;
    line-height: 22px;
    width: 250px;
    text-align: left;
    .tilte {
      color: $normal-color;
    }
    .desc {
      margin-top: 4px;
      color: $normal-color-dark;
    }
    .gap {
      margin: 6px 0px;
      width: 100%;
      height: 1px;
      background: $border-color;
    }
  }
}
.cells-bg {
  background: #ebebeb;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
</style>